export class AircraftSearchCriteria {
    public faaNumber: string;
    public customerNumberId: number;
}
